import * as React from "react";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NavLink } from "react-router-dom";
import "./StyleHamburger.css";

// Menu item component with accordion support
const MenuItem = ({ text, path, toggleOpen, toggleOrari, isCollapsible, subPaths, isZooming }: any) => {
    const [isExpanded, setExpanded] = useState(false);

    const handleClick = () => {
        if (path) {
            toggleOpen();  // Close the main menu for regular navigation paths
        } else if (text === "Orari") {
            toggleOpen();
            toggleOrari();  // Handle the "Orari" item separately
        } else if (isCollapsible && !isZooming) {
            setExpanded(!isExpanded);  // Toggle the accordion for collapsible items, only if not zooming
        }
    };

    const handleSubItemClick = () => {
        toggleOpen(); // Close the menu when a submenu item is clicked
    };

    return (
        <>
            <motion.li
                className="hamburg"
                onClick={handleClick}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
            >
                <div className="text-placeholder">
                    {path ? (
                        <NavLink to={"/" + path} className="hamburg-text">
                            {text}
                        </NavLink>
                    ) : (
                        <span className="hamburg-text">{text}</span>
                    )}

                    {/* Arrow Icon for Collapsible Items */}
                    {isCollapsible && (
                        <motion.span
                            className="arrow-icon"
                            animate={{ rotate: isExpanded ? 90 : 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            ➤
                        </motion.span>
                    )}
                </div>
            </motion.li>

            {/* Accordion section for collapsible items */}
            {isCollapsible && (
                <AnimatePresence>
                    {isExpanded && (
                        <motion.section
                            initial="collapsed"
                            animate="open"
                            exit="collapsed"
                            variants={{
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                            }}
                            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
                            className="accordion-content"
                        >
                            {Array.isArray(subPaths) && subPaths.map((subPath, index) => (
                                <motion.div
                                    key={index}
                                    style={{ paddingTop: "6px" }}
                                    variants={{ collapsed: { scale: 0.8 }, open: { scale: 1 } }}
                                    transition={{ duration: 0.8 }}
                                    className="content-placeholder"
                                    onClick={handleSubItemClick} // Close menu on submenu click
                                >
                                    <NavLink
                                        style={{ margin: "0 0 0 30px" }}
                                        to={subPath.path}
                                        className="hamburg-text"
                                    >
                                        {subPath.label}
                                    </NavLink>
                                </motion.div>
                            ))}
                        </motion.section>
                    )}
                </AnimatePresence>
            )}
        </>
    );
};

// Navigation component with specific sub-paths for each collapsible item
export const Navigation = ({ toggleOpen, toggleOrari }: any) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [prevWindowWidth, setPrevWindowWidth] = useState(window.innerWidth);
    const [isZooming, setIsZooming] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const currentWindowWidth = window.innerWidth;

            // Verifica se la larghezza della finestra è cambiata drasticamente
            if (Math.abs(currentWindowWidth - prevWindowWidth) > 50) {
                setIsZooming(true);  // Probabilmente è stato uno zoom
            } else {
                setIsZooming(false); // Nessun zoom rilevato
            }

            setPrevWindowWidth(currentWindowWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [prevWindowWidth]);  // Monitoriamo solo la larghezza della finestra

    return (
        <motion.ul className="hamburg scrollbar-left" style={{overflowY:"auto", scrollbarColor: "white"}}>
            <MenuItem
                text="Il Centro"
                toggleOpen={toggleOpen}
                isCollapsible={true}
                subPaths={[
                    { path: "/chisiamo", label: "Chi siamo" },
                    { path: "/contatti", label: "Contatti" },
                    { path: "/calendario", label: "Calendario" },
                    { path: "/regolamento", label: "Regolamento" },
                ]}
                isZooming={isZooming}
            />
            <MenuItem text="Piscina" path="piscina" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem text="Palestra" path="palestra" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem text="Fitness" path="fitness" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem text="Danza" path="danza" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem text="Runnering" path="runnering" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem text="SPA" path="spa" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem text="Multitessere" path="multitessere" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem
                text="Altri servizi"
                toggleOpen={toggleOpen}
                isCollapsible={true}
                subPaths={[
                    { path: "/visitemediche", label: "Visite mediche" },
                    { path: "/abbigliamento", label: "Abbigliamento" },
                ]}
                isZooming={isZooming}
            />
            <MenuItem text="News" path="news" toggleOpen={toggleOpen} isZooming={isZooming} />
            <MenuItem text="Orari" path="" toggleOpen={toggleOpen} toggleOrari={toggleOrari} isZooming={isZooming} />
        </motion.ul>
    );
};
